import { normalize } from 'normalizr';

import alarmsConfigSchema from '../normalizr-schemas/alarmsConfigSchema';
import { post, deleteEntity } from '../utils/communications';
import { apiEndpoint } from '../utils/env';
import commonActions from './common';

const alarmsConfigActions = commonActions('alarmsConfig');

export const submitAlarmConfig = configuration => (dispatch, getState) => {
  const {
    configId, machinesId, yellowConfig, redConfig,
  } = configuration;
  if (configId) {
    dispatch(alarmsConfigActions.submitUpdateItem(configId));
  } else {
    dispatch(alarmsConfigActions.submitAddItem());
  }

  const organisationId = getState().currentOrganisation;

  const body = {
    data: {
      type: 'alarmsConfig',
      attributes: {
        configId,
        organisationId,
        machinesId,
        yellowConfig,
        redConfig,
      },
    },
  };

  post(`${apiEndpoint}/organisations/${organisationId}/alarms-config`, body)
    .then((config) => {
      const normalizedData = normalize(config.data.attributes.config, alarmsConfigSchema);
      // If there is a configId, then we update, if not we create a new one
      if (configId) {
        return dispatch(alarmsConfigActions.updateItem('alarmsConfig', normalizedData));
      }
      dispatch(alarmsConfigActions.storeItems('alarmsConfig', normalizedData));
      return dispatch(alarmsConfigActions.closeNewModal());
    })
    .catch((err) => {
      console.log(err);
    });
};

export const deleteMachineConfig = id => (dispatch, getState) => {
  dispatch(alarmsConfigActions.submitDeleteItem(id));
  const organisationId = getState().currentOrganisation;
  deleteEntity(`${apiEndpoint}/organisations/${organisationId}/alarms-config/${id}`)
    .then(() => dispatch(alarmsConfigActions.deleteItem(id)));
};



// WEBPACK FOOTER //
// ./src/actions/alarmsConfig.js